import { useApi } from "./api";
import { createAdminCrudApi } from "./createAdminCrudApi";
import { SearchPendingUsersResponse, UpdatePendingUserBody } from "./types/pendingUsers";

// Added with useUsersApi().addUser.
export const usePendingUsersApi = () => {
  const crud = createAdminCrudApi<SearchPendingUsersResponse, never, UpdatePendingUserBody>(
    useApi(),
    "/admin",
    "pending_users",
  );

  return {
    usePendingUsers: crud.useSearch,
    updatePendingUser: crud.update,
    deletePendingUser: crud.remove,
  };
};

export default usePendingUsersApi;
